module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "bullhorn"
    }
  }, [_c('div', {
    class: {
      clearfix: _vm.headerCampaignOpen
    },
    attrs: {
      "slot": "head"
    },
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('campaign_field.title.campaign-info'))), (_vm.headerCampaignOpen) ? _c('b-btn', {
    staticClass: "float-right",
    attrs: {
      "size": "sm",
      "to": {
        name: "campaign",
        params: {
          code: _vm.campaign.code
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.buttons.open')))]) : _vm._e(), (_vm.showStatus) ? _c('campaign-status', {
    staticStyle: {
      "float": "right"
    }
  }) : _vm._e()], 1), _c('template', {
    slot: "content"
  }, [(_vm.campaign.target_change_status) ? _c('div', {
    staticClass: "row mt-1"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 mt-2"
  }, [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('campaign_field.title.target_change_status')))]), _c('span', {
    staticClass: "box-widget-list-value"
  }, [_vm._v(_vm._s(_vm.$t(("terms.target_change_status." + (_vm.campaign.target_change_status)))))])]), _c('div', {
    staticClass: "col-md-6 col-sm-6 mt-2"
  }, [_c('campaign-target-popup', {
    attrs: {
      "target": _vm.changedTarget,
      "target_change_status": _vm.campaign.target_change_status
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "row mt-1"
  }, _vm._l((_vm.visibleFields), function(field) {
    return _c('div', {
      staticClass: "col-md-6 col-sm-6 mt-2"
    }, [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(field.name))]), _c('span', {
      staticClass: "box-widget-list-value"
    }, [(["campaign.clone_of", "campaign.clone_for", "duplicate_of"].indexOf(field.slug) !== -1) ? _c('b-btn', {
      attrs: {
        "variant": "link",
        "to": {
          name: 'campaign',
          params: {
            code: field.value
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.isEmpty(field.value)))]) : _vm._e(), (field.slug === "facebook_pixel") ? _c('facebook-pixel', {
      attrs: {
        "pixel": field.value
      }
    }) : [_vm._v(_vm._s(_vm.isEmpty(field.value)))]], 2)])
  })), (_vm.canEditCreator) ? _c('div', {
    staticClass: "row mt-1"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 mt-2"
  }, [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.getFieldByName('campaign.creator_email').name))]), _c('span', {
    staticClass: "box-widget-list-value"
  }, [_vm._v(_vm._s(_vm.getFieldByName('campaign.creator_email').value))])]), _c('div', {
    staticClass: "col-md-6 col-sm-6 mt-2"
  }, [_c('b-btn', {
    on: {
      "click": _vm.openCreatorModal
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.buttons.edit')))])], 1)]) : _vm._e(), (_vm.canMoveCampaign) ? _c('div', {
    staticClass: "row mt-1"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('gotu-nav-button', {
    staticClass: "mb-2 float-right",
    attrs: {
      "theme": "default-cta"
    },
    on: {
      "click": _vm.forceMoveCampaign
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.move-campaign')))])], 1)]) : _vm._e()])], 2), _c('b-modal', {
    ref: "modal",
    staticClass: "creator-modal",
    attrs: {
      "size": "md",
      "title": _vm.$t('pos.campaign.change-creator-modal.title'),
      "fade": false,
      "closeTitle": _vm.$t('pos.buttons.close')
    }
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "placeholder": _vm.$t("pos.campaign.change-creator-modal.placeholder")
    },
    model: {
      value: (_vm.newCreatorEmail),
      callback: function($$v) {
        _vm.newCreatorEmail = $$v
      },
      expression: "newCreatorEmail"
    }
  }), _c('div', {
    staticClass: "change-creator-desc"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.change-creator-modal.description')))])], 1), _c('template', {
    slot: "modal-footer"
  }, [_c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.changeCreator
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.change')))]), _c('gotu-nav-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.cancel')))])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d71ee98"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-info/CampaignInfo.vue
// module id = 2069
// module chunks = 1